module.exports = __webpack_public_path__ + "static/media/Asset 151.48241852.png";